import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { keyframes } from "@emotion/react";
import { useTheme } from "@mui/material/styles";

const innerPulse = keyframes`
  0% { transform: scale(0.8); opacity: 0.7; }
  50% { transform: scale(1.2); opacity: 1; }
  100% { transform: scale(0.8); opacity: 0.7; }
`;

const outerBurst = keyframes`
  0% { transform: scale(1); opacity: 0.4; }
  100% { transform: scale(2); opacity: 0; }
`;

const PulseBurst = () => {
  const theme = useTheme();
  const [triggerBurst, setTriggerBurst] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const interval = setInterval(() => {
      if (isMounted) {
        setTriggerBurst(true);
        setTimeout(() => {
          if (isMounted) setTriggerBurst(false);
        }, 500);
      }
    }, 3000);

    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, []);

  return (
    <Box
      sx={{
        width: "16px",
        height: "16px",
        position: "relative",
        marginRight: "8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {triggerBurst && (
        <Box
          sx={{
            position: "absolute",
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            backgroundColor: theme.palette.success.light,
            animation: `${outerBurst} 0.6s ease-out`,
            zIndex: 0,
          }}
        />
      )}

      <Box
        sx={{
          width: "8px",
          height: "8px",
          borderRadius: "50%",
          backgroundColor: theme.palette.success.main,
          animation: `${innerPulse} 3s ease-in-out infinite`,
          zIndex: 1,
        }}
      />
    </Box>
  );
};

export default PulseBurst;
